import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ChatbotService } from './service/chatbot.service';
import { ChatMessage } from './interface/chatbot.interface';
import { ButtonModule } from 'primeng/button';
import { FormsModule } from '@angular/forms';
import { InputTextModule } from 'primeng/inputtext';

@Component({
  selector: 'app-chatbot',
  standalone: true,
  imports: [FormsModule, ButtonModule, InputTextModule],
  templateUrl: './chatbot.component.html',
  styleUrl: './chatbot.component.scss',
})
export class chatbotComponent implements OnInit {
  @ViewChild('scrollContainer') scrollContainer!: ElementRef;

  messages: ChatMessage[] = [];
  userInput = '';
  loading = false;

  constructor(private chatbotService: ChatbotService) {}

  ngOnInit() {
    this.loadInitial();
  }

  loadInitial() {
    this.chatbotService.getInitialData().subscribe((msg) => {
      this.messages.push(msg);
      this.scrollToBottom();
    });
  }

  currentStep: 'initial' | 'options' | 'ia' = 'initial';
  lastOptionId: number | null = null;
  sendMessage() {
    const value = this.userInput.trim();
    if (!value) return;

    this.messages.push({
      text: value,
      sender: 'user',
      timestamp: new Date(),
    });

    this.userInput = '';
    this.loading = true;

    if (this.currentStep === 'ia') {
      if (value.toLowerCase() === 'salir') {
        this.currentStep = 'initial';
        this.messages.push({
          text: '🔙 Has salido del modo IA de ChatBot',
          sender: 'bot',
          timestamp: new Date(),
        });
        this.loadInitial();
        this.loading = false;
        return;
      }

      this.chatbotService.consultarIA(value).subscribe({
        next: (response) => {
          this.messages.push(response);
          this.loading = false;
          this.scrollToBottom();
        },
        error: () => this.handleError(),
      });
      return;
    }

    const id = Number(value);

    if (isNaN(id)) {
      this.messages.push({
        text: '⚠️ Solo se permiten números (ej: 1, 2, 3)',
        sender: 'bot',
        timestamp: new Date(),
      });
      this.loading = false;
      return;
    }

     if (this.currentStep === 'initial') {
      this.chatbotService.getByIdOptions(id).subscribe({
        next: (response) => {
          this.messages.push(response);
          this.currentStep = 'options';
          this.lastOptionId = id;
          this.loading = false;
          this.scrollToBottom();
        },
        error: () => this.handleError(),
      });
    }

    else if (this.currentStep === 'options') {
      if (id === 63) {
        this.currentStep = 'ia';

        this.messages.push({
          text: '🤖 Has entrado al modo IA de ChatBot, escribe tu consulta. Si deseas Salir escribe "Salir"',
          sender: 'bot',
          timestamp: new Date(),
        });

        this.loading = false;
        return;
      }

      this.chatbotService.getById(this.lastOptionId!, id).subscribe({
        next: (response) => {
          this.messages.push(response);

          this.currentStep = 'initial';
          this.lastOptionId = null;

          this.loadInitial();

          this.loading = false;
          this.scrollToBottom();
        },
        error: () => this.handleError(),
      });
    }
  }

  handleError() {
    this.messages.push({
      text: '❌ Error consultando la opción, digite una opción válida',
      sender: 'bot',
      timestamp: new Date(),
    });
    this.loading = false;
  }

  scrollToBottom() {
    setTimeout(() => {
      if (this.scrollContainer?.nativeElement) {
        this.scrollContainer.nativeElement.scrollTop =
          this.scrollContainer.nativeElement.scrollHeight;
      }
    }, 100);
  }

  onInputChange(event: any) {
    const value = event.target.value;

    if (this.currentStep === 'ia') {
      this.userInput = value;
    } else {
      this.userInput = value.replace(/[^1-9]/g, '');
    }
  }

  chatState: 'closed' | 'open' | 'maximized' = 'closed';

  toggleChat() {
    if (this.chatState === 'closed') {
      this.chatState = 'open';
    } else {
      this.chatState = 'closed';
    }
  }

  maximizeChat() {
    this.chatState = 'maximized';
  }

  minimizeChat() {
    this.chatState = 'open';
  }

  closeChat() {
    this.chatState = 'closed';
  }
}
